import { ConfirmDialog } from '@gogame/components';
import { useScreenMessage, useScreenModalV2 } from '@gogame/screens';

import {
  uploadFile,
  checkStatus,
} from 'scenes/BulkUpload/sources/bulk-uploader';

export const useUpload = (process, messagesProcess) => {
  const { showErrorMessage } = useScreenMessage();
  const showModal = useScreenModalV2(ConfirmDialog);

  const uploadAndCheck = async (params) => {
    let uploadResponse = await uploadFile(params).catch((e) => {
      showErrorMessage(e.message);
      return Promise.reject(e);
    });
    const checkStatusesProcess = async () => {
      let statusResponse = await checkStatus({
        jobId: uploadResponse.jobId,
        partner: params.partner,
      }).catch((e) => {
        showErrorMessage(e.message);
        return Promise.reject(e);
      });
      messagesProcess(statusResponse.messages);
      if (!statusResponse.isCompleted) {
        await new Promise((res) => setTimeout(res, 1000));
        return await checkStatusesProcess();
      }
      return statusResponse;
    };
    return checkStatusesProcess();
  };

  return async (params) => {
    await showModal({
      title: `Confirm`,
      confirmActionLabel: 'Upload',
      bodyText: `Are you sure you want to upload ${params.file.name} to ${params.partner}?`,
    });
    return process(uploadAndCheck(params));
  };
};
